module.exports = __webpack_public_path__ + "img/tmt-right.a2d47fa1.png";